<template>
    <div class="opui-container">
        <div class="optpl-details-container">
            <a href="#" @click.prevent="" class="optpl-back opui-skeleton-shimmer"><i class="opui-fa opui-fa-arrow-left"></i> Go back</a>

            <div class="optpl-details-card">
                <div class="optpl-details-card__info">
                    <h2 class="opui-skeleton-shimmer">Lorem</h2>
                    <div class="opui-skeleton-shimmer">Lorem ipsum</div>
                    <div class="opui-skeleton-shimmer">Lorem ipsum</div>
                    <div class="opui-skeleton-shimmer">Lorem ipsum</div>
                    <div class="opui-skeleton-shimmer">Lorem ipsum</div>
                    <div class="opui-skeleton-shimmer">Lorem ipsum</div>
                    <div class="opui-skeleton-shimmer">Lorem ipsum</div>
                    <div class="opui-skeleton-shimmer">Lorem ipsum</div>
                    <div class="opui-skeleton-shimmer">Lorem ipsum</div>
                    <div class="opui-skeleton-shimmer">Lorem ipsum</div>
                    <div class="opui-skeleton-shimmer">Lorem ipsum</div>
                    <div class="opui-skeleton-shimmer">Lorem ipsum</div>
                    <div class="opui-skeleton-shimmer">Lorem ipsum</div>
                    <div class="opui-skeleton-shimmer">Lorem ipsum</div>
                    <div class="opui-skeleton-shimmer">Lorem ipsum</div>
                    <p class="opui-skeleton-shimmer" style="max-width: 460px;">Lorem ipsum</p>

                    <div class="optpl-details-card__tags-container">
                        <div class="optpl-details-card__tags">
                            <h3 class="opui-skeleton-shimmer" style="max-width: 200px;">Lorem</h3>
                            <span v-for="tag in tags" class="opui-skeleton-shimmer">Tags</span>
                        </div>
                        <div class="optpl-details-card__tags">
                            <h3 class="opui-skeleton-shimmer" style="max-width: 150px;">Lorem</h3>
                            <span v-for="tag in tags" class="opui-skeleton-shimmer">Tag</span>
                        </div>
                    </div>

                    <div class="optpl-details-card__actions">
                        <a class="opui-btn opui-btn-outline opui-skeleton-shimmer"><i
                                class="opui-fa opui-fa-play-circle-o"></i> Live Preview</a>
                        <a href="#" class="opui-btn opui-btn-primary opui-skeleton-shimmer">Start with this template</a>
                    </div>
                </div>

                <div class="optpl-details-card__media">
                    <figure class="opui-skeleton-shimmer" style="height: 550px;"></figure>
                </div>
            </div>

            <div class="optpl-details-related">
                <TemplatesAreLoading />
            </div>
        </div>
    </div>
</template>

<script>
import TemplatesAreLoading from './TemplatesAreLoading.vue';

export default {
    data() {
        return {
            tags: 3,
        };
    },
    components: { TemplatesAreLoading }
}
</script>
